import React from "react";
import Header from "../Header";
import Footer from "../Footer";

import { Link } from "react-router-dom";
import AudioPlayer from "../Audio/AudioPlayer";

const BlogDetails4 = (props) => {
  const img1 = "/assets/wp-content/uploads/2018/12/ramdev-gallery34.jpg"
  return (
    <>
     <meta name="keywords" content="બાબા રામદેવ , રામદેવજી,  રામદેવ પીર, રામશા પીર, Baba Ramdev, Ramdevji, Ramdev Pir, Ramshapir" />
      
      <Header />

      <div
        data-elementor-type="cpt_layouts"
        data-elementor-id="46"
        className="elementor elementor-46"
      >
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-52ebb12  elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="52ebb12"
          data-element_type="section"
          data-settings='{"background_background":"classic"}'
          style={{ height: "30rem", marginBottom: "5rem" }}
        >
          <div className="elementor-background-overlay"></div>
          <div className="elementor-container elementor-column-gap-extended">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-ae9d67e sc_inner_width_none sc_layouts_column_icons_position_left"
              data-id="ae9d67e"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <section
                  className="elementor-section elementor-inner-section elementor-element elementor-element-fcf91b3 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="fcf91b3"
                  data-element_type="section"
                >
                  <div className="elementor-container elementor-column-gap-extended">
                    <div
                      className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-93dfaf4 sc_inner_width_none sc_layouts_column_icons_position_left"
                      data-id="93dfaf4"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="sc_layouts_item elementor-element elementor-element-847c2c5 sc_fly_static elementor-widget elementor-widget-spacer"
                          data-id="847c2c5"
                          data-element_type="widget"
                          data-widget_type="spacer.default"
                          style={{ height: "8rem" }}
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-spacer">
                              <div className="elementor-spacer-inner"></div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="sc_layouts_item elementor-element elementor-element-8fe49e3 sc_fly_static elementor-widget elementor-widget-trx_sc_layouts_title"
                          data-id="8fe49e3"
                          data-element_type="widget"
                          data-widget_type="trx_sc_layouts_title.default"
                        >
                          <div className="elementor-widget-container">
                            <div
                              id="trx_sc_layouts_title_515615674"
                              className="sc_layouts_title sc_align_center with_content without_image without_tint"
                            >
                              <div className="sc_layouts_title_content">
                                <div className="sc_layouts_title_title">
                                  {" "}
                                 
                                </div>
                                <div className="sc_layouts_title_breadcrumbs">
                                  <div className="breadcrumbs">
                                   
                                  </div>
                                </div>
                              </div>
                            </div>{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* <div className="menu_mobile_overlay"></div>
      <div className="menu_mobile menu_mobile_fullscreen scheme_inherit">
        <div className="menu_mobile_inner">
          <a className="menu_mobile_close icon-cancel"></a>
          <Link to={'/'} className="sc_layouts_logo">

            <img
              src={logoimg}
              alt="Vihara"
              width="134"
              height="78"
            />{" "}
          </Link>
          <nav
            className="menu_mobile_nav_area"
            itemScope
            itemType="//schema.org/SiteNavigationElement"
          >
            <ul id="menu_mobile_1510458944">
              <li
                id="menu_mobile-item-203"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-203"
              >
                <a href="/">
                  <span>Home</span>
                </a>

              </li>
              <li
                id="menu_mobile-item-204"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-204"
              >
                <a href="#">
                  <span>Gallery</span>
                </a>
                <ul className="sub-menu">
                  <li
                    id="menu_mobile-item-209"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-209"
                  >
                    <a href="/Audio">
                      <span>Audio</span>
                    </a>
                  </li>
                  <li
                    id="menu_mobile-item-208"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-208"
                  >
                    <a href="/Video">
                      <span>Video</span>
                    </a>
                  </li>
                  <li
                    id="menu_mobile-item-206"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-206"
                  >
                    <a href="/Gallery2">
                      <span>Images</span>
                    </a>
                  </li>

                </ul>
              </li>
              <li
                id="menu_mobile-item-224"
                className="menu-item menu-item-type-custom menu-item-object-custom current-menu-ancestor current-menu-parent menu-item-has-children menu-item-224"
              >
                <a href="#">
                  <span>About</span>
                </a>
                <ul className="sub-menu">
                  <li
                    id="menu_mobile-item-447"
                    className="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-407 current_page_item menu-item-447"
                  >
                    <a
                      href="/About"
                      aria-current="page"
                    >
                      <span>Ashram</span>
                    </a>
                  </li>

                  <li
                    id="menu_mobile-item-449"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-449"
                  >
                    <a href="/plan-visit">
                      <span>Plan a Visit</span>
                    </a>
                  </li>
                </ul>
              </li>

              <li
                id="menu_mobile-item-316"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-316"
              >
                <a href="/BlogMain">
                  <span>Stories</span>
                </a>
              </li>
              <li
                id="menu_mobile-item-312"
                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-312"
              >
                <a href="/Books">
                  <span>Books</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div> */}


      <div className="page_content_wrap blog-details">
        <div className="content_wrap" >
          <div className="content">
            <div id="container" className="give-wrap container">
              <div id="content" role="main">
                <div
                  id="give-form-288-content"
                  className="post-288 give_forms type-give_forms status-publish has-post-thumbnail"
                >
                  <div
                    id="give-sidebar-left"
                    className="give-sidebar give-single-form-sidebar-left"
                  >
                    <div className="images">
                      <img
                        width="1024"
                        height="576"
                        src={img1}
                        className="attachment-large size-large wp-post-image blog-img"
                        alt=""
                        decoding="async"
                        // srcSet="https://vihara.themerex.net/wp-content/uploads/2018/12/post-10-copyright-1024x576.jpg 1024w, https://vihara.themerex.net/wp-content/uploads/2018/12/post-10-copyright-300x169.jpg 300w, https://vihara.themerex.net/wp-content/uploads/2018/12/post-10-copyright-768x432.jpg 768w, https://vihara.themerex.net/wp-content/uploads/2018/12/post-10-copyright-1536x864.jpg 1536w, https://vihara.themerex.net/wp-content/uploads/2018/12/post-10-copyright-370x208.jpg 370w, https://vihara.themerex.net/wp-content/uploads/2018/12/post-10-copyright-1170x658.jpg 1170w, https://vihara.themerex.net/wp-content/uploads/2018/12/post-10-copyright-760x428.jpg 760w, https://vihara.themerex.net/wp-content/uploads/2018/12/post-10-copyright-270x152.jpg 270w, https://vihara.themerex.net/wp-content/uploads/2018/12/post-10-copyright.jpg 1920w"
                        sizes="(max-width: 1024px) 100vw, 1024px"
                      />
                    </div>
                  </div>
                  <div className="summary entry-summary">
                    <h2 itemProp="name" className="give-form-title entry-title">
                      લીલુડો ઘોડો
                    </h2>{" "}
                    <div
                      id="give-form-288-wrap"
                      className="give-form-wrap give-display-onpage"
                    >
                      <div className="give-goal-progress">
                        <div
                          className="raised blog-title"
                          
                        >
                          <span className="income">લીલુડો ઘોડો</span>
                        </div>
                      </div>

                      <div
                        id="give-form-content-288"
                        className="give-form-content-wrap give_pre_form-content"
                      >
                        <p className="paragraph-content" >
                          હીરચીરને થોડલે, થયા રામદે' સ્વાર, થનગન નાચી અશ્વ એ, ચડયો ગગનમોજાર,
                          શ્રી રામદેવજી બણ વરસની ઉંમરના થયા. તેમનાં બુદ્ધિ, ચાતુર્ય, સમજસિહ- અને વાતચીત કરવાની કુશળતાથી સૌ કોઈ અંજાઈ જતાં હતાં. રામદેવ ખોળામાં બેસાડી રાજમહેલના ઝરૂખામાં રાણી મિણલદે બેઠાં હતાં, એટલામ રામકુંવરને દૂધ પાવા ઝારી લઈને દાસી આવી. બરાબર એ સમયે મહેલના ઝરૂપ નીચેથી એક ઘોડેસ્વારને જતો રામદેવજીએ દીઠો અને એવા ઘોડા પર બેસવાન હઠ લીધી. તેઓ બોલ્યા કે, મા ! મને આવો ઘોડો અપાવો તો જ દૂધ પીઉ,
                          બાળહઠ આગળ કોઈનો ઉપાય ચાલ્યો નહીં. છેવટે ગામમાંથી મેરિયા નામન દરજીને તેડાવી એને લૂગડાનો મોટો થોડો બનાવી આપવાનું કહ્યું અને મિણલદેમં લીલા રંગના રેશમી રેજા આપ્યા. દરજી રેજા લઈ ગયો અને તત્કાલ થોડો બનાવ લઈ આવ્યો. સુંદર રૂડો રૂપાળો ઘોડો જોતાં રામદેવજી દૂધ પી અને ઘોડેસ્વાર થયા ત્યાં એક ચમત્કાર બન્યો ! લૂગડાનો થોડો ત્યાંથી છલંગ મારીને રામદેવજીને લઈને ઝરૂખા પરથી ઊડયો અને જોતજોતામાં અદૃશ્ય થઈ ગયો !
                          મિણલદે, દાસદાસીઓ આંચકો ખાઈ ગયાં! ગભરાઈ ગયાં. અજમલજીને ખબર મળતાં તેઓ દોડી આવ્યા અને દરજી પર ગુસ્સે થઈ બોલ્યા: 'અલ્યા મેરીયા ! આજ મને ખબર પડી કે તું જંતરમંતર જાણે છે. થોડો કઈ દિશાએ ઉડાડયો পাও?'
                          “મહારાજ ! થોડાને ઊછળીને ઊડતો દેખી હું પણ વિચારમાં પડી ગયો છું. અન્નદાતા !' મેરિયાએ ધ્રૂજતા ધ્રૂજતાં કહ્યું. 'આ દુષ્ટને પકડીને લઈ જાવ અને અંધારી કોટડીમાં પૂરી દો.' અજમલજીએ
                        </p>
                        <p className="paragraph-content">
                          હુકમ કર્યો. સૈનિકોએ દરજીને પકડીને કોટડીમાં પૂરી દીધો.
                          'રામદેવ મહારાજ ! તમે પૃથ્વી પર પધાર્યા ત્યારે કંકુનાં પગલાં પાડયાં હતાં. ઊકળતા દૂધની દેગડી તમોએ જ ઉતારી હતી. એ પરચા પીરાઈનાં મેં પલ દર્શન કર્યા હતાં. આપ તો હિન્દવાપીર છો. મહારાજ ! આપના માટે પ્રેમથી થોડલો બનાવ્યો હતો. તેના બદલામાં બાપુએ મને અંધારી કોટડીમાં પૂરી દીધો ? મને આ નરકમાંથી છોડાવો અન્નદાતા !' આટલું કહેતાં તેની આંખમાંથી આંસુ વહેવા લાગ્યાં. તે રામદેવપીરની સ્તુતિ કરવા લાગ્યો.
                          સાંજના સમયે માતા મિણલદેને દાસીએ ખબર આપી કે, કુંવર થોડો લઈને દરબારગઢમાં રમે છે.
                          અજમલજીએ મેરીયાને છોડી મૂક્યો કે, તરત તે દોડતો આવીને રામદેવપીરના પગમાં પડયો અને બોલ્યો: 'કૃપાનાથ! આપે નિર્જીવ ધોડાને સજીવન કર્યો અને મને જીવતાને મારવાનો પરચો ? મારો કંઈ અપરાથ?!
                          “મેરીયા ! તેં રેશમનો ઘોડો બનાવ્યો પણ તેમાં તે જૂનાં કપડાંનાં ચીંથરાં ભર્યાં હતાં. તેની સજા તને મળી ગઈ છે. હવેથી તું એવું કરીશ નહિ. તેમજ વિધર્મીઓ કે ફકીરોને શેરખાનની કબર કે હસ્તી બીબીના ગોખલા ઉપર ચઢાવવા માટે તું અંધશ્રદ્ધાળુઓને ઘોડા બનાવી આપે છે. હવેથી એમ કરીશ તો તારા ઉપર અનેક પ્રકારનાં દુ:ખો આવી પડશે. તને મારી આશા છે કે, હિન્દવાપીરના થાનક, મઠ, મંદિર કે પીરાઈવાળા સાધુસંતોની સમાધિને પૂજનારા ભક્તો માટે ઘોડાના પ્રતિક બનાવજે અને નિજીયા ધર્મનો ઉપાસક બનજે. તને હું સહાય કરીશ. આ સાંભળી મેરીયો ચરણોમાં પડ્યો. અને ચરણસ્પર્શ કરવાથી એને દિવ્ય પ્રકાશ દેખાયો અને તે મેરાઈ ભક્તના નામે પ્રસિદ્ધ થયો.
                          દોહા સોરઠનો આહિર વજો, કરે રેવત વહેપાર, અશ્વ લઈને આવિયો, અજમલજીને દ્વાર. સોરઠ પ્રદેશમાંથી એક આહીર પોકરણમાં આવી અજમલજીના દરબારગઢના ચોકમાં આવીને ઊભો. એને દોઢી દરવાને ટપારવાથી એણે કહ્યું કે, હું થોડાનો
                        </p>

                        {/* 3 to 4 */}
                        <p className="paragraph-content" >
                          માંદાગર છું અને રાજાને મારો થોડો બતાવવા આવ્યો વતા રાજમહેલાય અંઘરપરસાયાડી તેથી અજમલજી, વીરમદેવજી અને રામદેવજી ત્યાં આવ્યા. તેમને નમન કરી ઊભો. વજાને અજમલજીએ પ્રાછયું : 'પુવાન ! હું કયાંનો છે વધા તે? કેમ આવ્યો છે ?” વજે થોડાને બતાવતાં પોતાની ઓળખાણ આપી
                          જણાવ્યું કે :
                          દોહા છું સોદાગર અશ્વનો, રેવતનો વહેપાર, ભટક વછેરો લાવિયો, જોઈ કરો વિચાર.
                          મહારાજ ! હું સોરઠ ભૂમિનો વતની છું. નાના મોટા ઘોડા ખરીદવા અને વેચા એ મારો ધંધો છે. મારું નામ વજો આહીર છે. હું મારી સાથે પાંચ ઘોડા લઈ મેવા ભોમમાં ગયો હતો. ત્યાં તે વેચાઈ ગયા. વાત સાંભળી કે પોકરણગઢના રાષ્ટ્ર અજમલજીને ત્યાં એક પ્રતાપી પરચાધારી કુંવર છે. તેમનું નામ રામદેવજી છે. એટલે હું તેમને જુહાર કરવા અહીં આવ્યો છું. થોડા તો બધા વેચાઈ ગયા, પરંતુ આ બટુક વછેરો હતો તે સાથે લાવ્યો છું. વજાએ બે હાથે પ્રણામ કરીને નમ્રતાથી કહ્યું. હવ્યપુષ્ટ અંગવાળો બટુક-વછેરો જોઈ રામદેવજી એની પાસે ગયા. વછેરાએ રામદેવજીને જોતાં તેમની દૃષ્ટિમાં દૃષ્ટિ મેળવીને સહેજ માથું નીચું નમાવ્યું. એ વખતે રામદેવજી એની લગામ વાગદોર જાલી, એની પીઠે હાથ ફેરવીને તેને થાબડયો. અજમલજીએ વજાને કહ્યું : 'ભાઈ ! અમારે ઘણા ઘોડા છે. વછેરો પરોળતાં એક વર્ષે રાંગળો થાય. વળી એ હાવળ હટો, હૈયા ફડકો, દળભુંજણો છે કે શત્રુજીત છે એ જાણ્યા સિવાય શું કામનો ? ઉંમરમાં નાનો છે. પરીક્ષા પણ શી રીતે કરવી?' વજો બોલ્યો : 'બાપુ ! તમે જે શંકાઓ કહી એ જાતનો આ રેવત નથી; અમારા વડવાઓ આ જાતના રૈવત વિષે વાતો કરે છે, તે મેં સાંભળી છે. જે આ વછેરામાં કોઈ પણ અપલક્ષણ હોત તો હું અહીં આવત જ નહીં.
                          સતયુગમાં સનાતન ધર્મના ઉપાસક પ્રહ્લાદ રાજાએ સવરામંડપમાં પાટપૂજ કરી એ વખતે ભગવાન નકળંગનાથ પધાર્યા અને સોનાના સિંહાસન પર બિરાજ્યા હતા. એમણે આ જાતના થોડાની ઘોડેસ્વારી કરી ત્યારથી એનું નામ નકળંગનાથી પડયું છે. ત્રેતાયુગમાં અયોધ્યાના રાજા હરિશ્વન્દ્રએ સવરામંડપ રોપી પાટપૂજા કરી.      </p>
                        <p className="paragraph-content" >
                          એ વખતે રૂપાનાં સિહાસન પર નકળંગરાય ભિરાજ્યા હતા. તેઓ આ જાતના અશ્વ પર સ્વાર થઈ આવ્યા હતા. તેથી એ 'હરિનાથી હેમર' ગણાયો. હાપરમાં હસ્તિનાપુરના રાજા યુધિષ્ઠરે સવરામંડપ રોપ્યો. એ વખતે ત્રાંભાનાં સિંહાસન પર નકળંગ ભગવાન બિરાજ્યા હતા અને રેવતાચળ તરફ પોડેસ્વાર થઈ પધાર્યા હતા. તેથી એ નકળંગનાથી દૈવત નામથી પ્રસિદ્ધ થયો. એ જાતનો આ અશ્વ છે. એના ગુણ સાંભળો :
                          દોહા
                          રેવત નૃપની રેવતી, વર્ષા પદુ બલદેવ, અશ્વ નવલખો આપીયો, નવતર એની ટેવ.
                          રેવતાચળ પર્વતના રેવત નામના રાજાએ પોતાની પુત્રી રેવતીને દ્વારકાના યદુરાય કૃષ્ણના મોટાભાઈ બલરામ સાથે લગ્ન કરાવ્યાં. તે સમયે ગિરનારમાં લગ્નોત્સવ કર્યો; એ વખતે રેવતીને દહેજમાં પરિયાણમાં નવલખો થોડો આપ્યો. એનું નામ રૈવત રાખ્યું. એ નવલખી જાતનો આ વછેરો છે મહારાજ ! વજાએ સ્પષ્ટિકરણ કરી સવિસ્તર વાત કહી.
                          “સોદાગર, આ નવલખો વછેરો છે ? એનામાં નવજાતની ટેવ છે ખરી ? સંભળાવો ?' અજમલજી અને બધાને વજાની વાત સાંભળી તેની વાતમાં રસ પડ્યો અને વધુ જાણવાની ઈચ્છા થતાં અજમલજીએ કહ્યું. વજાએ નમ્રતાથી બધા સાંભળે એ રીતે કહ્યું : 'હા, મહારાજ! આ વછેરામાં કહ્યા તે બધા જ ગુણો છે.
                          દોહા ઝપટે ઝડપે શત્રુને, મારે છલંગ ફાળ, દુશ્મન દળમાં ઘૂમતો, વેગ તેગ વિકારાળ.
                          કોઈ શત્રુવટ કરી ધોડેસ્વાર થઈ નાસી છૂટતો હોય ત્યારે આ અશ્વને ઇશારો કરતાં શત્રુની પાછળ ઝડપથી દોડી એને ઝડપીને નીચે પછાડી નાખે, ગમે તેવા ભયંકર દુશ્મન દળને ભેદવા આ અશ્વને ઈશારો કરતાં તરત મોટી ફાળો ભરતો દોડીને દુશ્મનના સૈન્યને ભેદી નાખે. વળી છલંગો મારી પોતાની ચપળતા, હિંમત, તેગવેગ જેવું ખમીર બતાવી દુશ્મનો વચ્ચે ઘૂમી-ઝઝૂમી કંઈકને પછાડી નાંખે     </p>

                        {/* 5-6 */}

                        <p className="paragraph-content" >
                          પોતાના પગના પ્રહારમાં પણ પાછો ના પડે એવી જાતનો આ વછેરો છું. ભાલકુંવર રામદેવજીને યોગ્ય આ એક ઉત્તમ જાતનો ભાલ અજી છે. mare te અશ્વો જગતમાં ભાગ્યે જ જોવા મળે છે.
                          વજાની વાત સાંભળી અજમલજીએ પોતાનો લીલુડો થોડો મંગાવ્યો. કહ્યું : 'જૂઓ, આ બાલકુંવરનો થોડો ! એનું નામ લીલુડો. એ નાના હતા જે બનાવડાવ્યો હતો.’
                          'મહારાજ ! આ તો રમકડું છે. ક્યાં આ વછેરો અને ક્યાં આ રમકડું ?' ભ આશ્ચર્ય પામી કહ્યું.
                          “એ રમકડા જેવા થોડાને પણ રામદેવજીએ રમતો કર્યો હતો. હવે તમારે તમઃ વછેરાની કિંમત શું લેવી છે? એ કહો.' અજમલજીએ પૂછ્યું.
                          ચોપાઈ
                          નવલખ સતગુણ સમસ્યા કરો, બહુ બલવંતો બટુક વછેરો, પટ-રેવતને બદલે આપું, બટુકને સ્વીકારો બાપુ.
                          'મહારાજ ! મારે કિંમત દ્રવ્ય નાણાં જોઈતાં નથી. મને આ લીલુડો થોકું બદલામાં આપો અને આ અશ્વનું નામ લીલુડો ધોડો રાખો. કુંવર રામદેવા ચમત્કારવાળા છે. એમની પ્રશંસા સાંભળીને હું એમનો આસ્તિક થયો છું. મને મ લૂગડાનો અશ્વ આપો. એને હું મારે ત્યાં પધરાવીને પૂજા કરીશ. વજાએ પોતાન મનની ઇચ્છા વ્યક્ત કરી. એ સાંભળી રામદેવજીએ પોતાનો લૂગડાનો થોડો દોરીને વજાને આપ્યો અને વછેરા પાસે જઈ એની પીઠ પર હાથ ફેરવતાં વછેરો નીચે નમ્યો. એટલે રામદેવજી છલંગ મારી તેના પર સ્વાર થયા. આ અદ્ભુત પ્રસંગ જોઈ અજમલજી, વીરમદેવજી, મિણલદેને હવે હરખ માતો ન હતો.
                          ચોપાઈ
                          બાલકુંવર કરે રેવત સ્વારી, હરખ્યા દાસ દાસી નરનારી, ધરી વાગ અજમલના લાલે, થનગન થનગન રેવત ચાલે.</p>
                        <p className="paragraph-content">
                          પોડાના ગળે બાંધેલી રામદેવજીએ ખેલવા લાગ્યો. એનું નામ લીલુડો થોડો રાખ્યું અને પોતાનો કપડાંનો લીલુડો થોડો વજા આહીરને બદલામાં આપ્યો. વજો કપડાંનો લીલુડો લોડો લઈ બધાને નમસ્કાર કરી ચાલતો થયો.
                          ચોપાઈ
                          દ્વારપાળ વિજય હતો, બન્યો વજો આહીર, હતો વછેરો ગરુડજી, જાણે રામાપીર.
                          દ્વારકાધિશનો વિજય નામનો હારપાલ હતો. તેને પ્રભુની આશા થવાથી એ વજા આહીર નામે જન્મ્યો હતો અને ગરુડજીએ વછેરાના રૂપે જન્મ લીધો હતો. આ વાત શ્રી રામદેવજી સારી રીતે જાણતા હતા.
                          ચોપાઈ
                          અજર અમર અવિનાશી સ્વામી, અખિલેશ્વર પ્રભુ અંતરયામી, ઉત્તર ખંડથી યોગી પધારે, શૃંગી બજાવે અજમલ દ્વારે. ઉત્તર દિશામાં આવેલા શ્વેતગિરિ હિમાચલમાંથી ભગવાન શંકર યોગીરૂપે અજમલજીના દ્વારે પધાર્યા અને 'હરિ ઓમ્ તત્ સત્'નો ઉચ્ચાર કરી શૃંગીનાદ
                          ગજાવ્યો.
                          ચોપાઈ
                          સુણીનાદ મિણલદે આવે, બે કર જોડી શીશ નમાવે, બાલકુંવર હું નીરખું બાઈ, દર્શનની ઈચ્છા મનમાંહી.
                          શૃંગીનાદ સાંભળી મિણલદેએ મહેલનાં દ્વાર ઉઘાડયાં તો તેમણે એક પ્રભાવશાળી યોગીને દીઠો. રાણીએ હાથ જોડી વંદન કરી માથું નમાવ્યું એટલે યોગીએ કહ્યું: 'બાઈ! તારા કુંવરને લઈ આવ. એની પ્રસંશા સાંભળીને હું તેને જોવા આવ્યો છું.'
                          યોગીની વાત સાંભળી મિણલદે વિસ્મય પામ્યા. માથે મોટી જટા, ગળામાં ભરડો લઈ બેઠેલો ફણીધર સાપ, કમ્મરે વ્યાપ્રચર્મ અને હાથમાં ત્રિશૂલવાળા આ
                        </p>

                        {/* 7-8 */}
                        <p className="paragraph-content"  >
                          ભયાનક યોગીને જોઈને રામદેવજી ભવભીત થઈ જાય એમ વીરમદેવજીને લઈ આવ્યાં. મિણલદેની આ [ ચતુરાઈ સમજી યોગી બોલ્યા
                          ચોપાઈ કુંવર જોઈ જોગંધર બોલે, આ કુંવર નહીં રામની તોલે, ભાલક બદલીને શીદ લાવો ? કંકુ પગલાંવાળો બતાવો? બેટી ! આ કુંવર રામકુંવરની તોલે લાગતો નથી. મને કંકુમ બાળકુંવર બતાવવાને બદલે એના મોટાભાઈને શીદ લાવી ? હું રામદેવકુંવરનુંય
                          આવ્યો છું. મહાત્મા ! ોગી ! બાપુ ! આપનો ભય ભરેલો સ્વાંગ જોઈ ભલભલા 18 જાય, ભયભીત થઈને ફૂજી જાય ! કાળજુ કંપી જાય એથી હું રામકુંવરને લાવીય નહીં. મિણલદેએ પોતાના મનમાં છુપાવેલી સાચી વાત કરી અને સવિનય જણા
                          ચોપાઈ
                          અંગ ભભૂતિ ગળે મુંડમાળા, જોગી દીસો છો ત્રિશૂળવાળા, જટાજુટ શિરે વિકરાળા, ડરી જાય મુજ કુંવર બાળા. 'મહાત્મા ! મારા રામ કુંવરને હું નહીં લાવું. તમને જોઈને બીવે એવો તમારું વેશ છે.' મિણલદેએ કહ્યું.
                          સોરઠો
                          વડછડ ચાલે વાતમાં, આવ્યા અજમલરાય, દીઠા અવધૂત યોગીને, નમ્યા ચરણની માંય.
                          પોતાના નિત્ય નિયમ મુજબ અજમલજી બહાર ફરીને આવ્યા. તેઓ અવજ યોગીરાજને જોઈ થોડેથી નીચે ઊતરી યોગીનાં ચરણે પડ્યા. 'જય મહાત્મન્ ! જય યોગીશ્વર ! આશા ?' અજમલે પૂછયું. 'મહારાજ ! મહાત્મા કહે છે કે બાલકુંવરને જોવા હું આવ્યો છું. અહીં લાવો. મેં એમને કહ્યું કે, કુંવર તમારી વેશ અને ગળે વીંટાળેલો સાપ જોઈને બીવે તેથી હું નહીં લાવું.”</p>
                        <p className="paragraph-content" >
                          'રાણી ! સાધુ-સંત, તપસી-યોગી, જતી-સતી અને મહાત્માઓ આપણા આંગણે આવે છે. એમનાં દર્શન દુર્લભ હોય છે. વળી અતિથિનો સત્કાર કરવો એ આપણો મુખ્ય ધર્મ છે. યોગીરાજની ઈચ્છા સંતોષવા કુંવરને લઈ આવો.” અજમલજીના કહેવાથી સતી મિઠ્ઠલદે રામદેવજીને તેડી લાવ્યાં. યોગીરાજ બાળકુંવરનાં દર્શન કરતાં બોલ્યાં : 'શી હરિની લીલા, હરિ ૐ તતુ સત' એમ કહી તેમણે રામદેવને વંદન કર્યા અને અજમલજી પ્રત્યે બોલ્યા.
                          ચોપાઈ
                          રાજન, સાજન લો મતવાલો, ભેટ ધરું હું ભમ્મર ભાલો, ધૂપ, ભસ્મ અને ધ્વજ ધોળો, આદિ ધર્મનો અલખ ઝોળો.
                          રાજા! તમે પતિપત્ની મહાભાગ્યવંત છો. રામકુંવરને જોઈ મને અનહદ આનંદ થયો છે. રામકુંવરને હું આ ભમ્મર ભાલો, ગુગલ ધૂપ, ભસ્મ, ધોળી ધર્મધજા, આદિપંથની અલખ ઝોળી એ મારી નિશાની તરીકે ભેટ આપું છું. યોગી મહાત્માની વાણી સાંભળી, અજમલજી, મિણલદે અને રામદેવજી એમના ચરણોમાં પડ્યાં અને યોગી આશીર્વાદ આપી ઉત્તર દિશા તરફ ચાલતા થયા. થોડા દિવસ પછી એક નવયુવાન દરબારગઢ આવ્યો અને અજમલજીને કહેવા લાગ્યો:
                          ચોપાઈ
                          સોરઠમાં વહેપાર કરતો, ગૌ સોદાગર નામ જયંતો, ફળદાયક થઈ બાધે મારી, દઉ વાછરડી લો સ્વીકારી.
                          રાજાજી ! મારવાડ, મેવાડ અને સોરઠ પ્રદેશમાં વાંઢિયા તરીકે ધંધો કરું છું. ગાયોને લેવી-દેવી એ મારો ધંધો છે. મેં ઘણા ઠેકાણે સાંભળ્યું કે, પોકરણગઢમાં બાળકુંવર રામદેવજી પ્રતાપી છે. જે એમની બાધા રાખે છે તે મનધાર્યા કામમાં સફળતા પ્રાપ્ત કરે છે. મારી પાસે એક વળોરી ગાય હતી. વળોરી ગાય જીવનભરની વંઝયા ગણાય છે. વળોરી ગાય ફળે જ નહિ. એને કાન-કુંવર કહેવામાં આવે છે. છે ગાય ફળે તો તેનું પહેલું બચ્ચું પીર રામદેવજીને ભેટ ધરવાની ઈચ્છા કરી દૂધ ખાવાની બાધા રાખી હતી. થોડા સમયમાં મારી બધા ફળી, ગાયે વાછરડીને જન્મ
                        </p>
                        <p className="paragraph-content" >
                          શ્રી રામદેવજીને ભેટ ધરી મારી બાષા પૂરી કરવા હું અહીં આવ્યો છું. વાછાય ચોપાઈ
                          વળોરી ગાવડી થઈ ફળતી, રામાપીરની બાધા ફળતી. અમરાપુરનો છું ગોમેતી, વાછડી ભેટ ધરું રામેતી. હું અમરાપુરનો ગોમતી છું. મારી આ રામેતી વાછરડીની ભેટ તમે સ્વીકારું અજમલજી, મિલલદે, રામદેવજી અને વીરમદેવજીએ સોદાગરની વાત સાંભળો રામદેવજીએ વાછરડી સામે દૃષ્ટિ કરતાં વાછરડી તેમની પાસે આવી માથું નમાટે ઊભી રહી. રામદેવજીએ તે વાછરડીના માથે હાથ ફેરવ્યો. આ પ્રસંગ તથા સુંદર વાછરડીને જોઈ લોકોનું દિલ હચમચી ગયું અને તેઓ બધાં તે વાછરડી પર પ્રક્ષણ થયાં. તેનો થોળો રંગ, કપાળમાં કંકુનો ચાંલ્લો હોય તેવું મંગળચિહ્ન બધાં ભાવપૂર્વક જોઈ રહ્યાં.
                          આ સોદાગર જયન્તો દ્વારકાધિશનો દ્વારપાલ જય (જયન્ત) હતો. જેમ આન પહેલાં ભગવાનનો દ્વારપાલ વિજય વજાના નામે આવીને વછેરો મૂકી ગયો હતો. તેમ દ્વારપાલ જય આવીને રામેતી ગાય મૂકી ગયા. આ પ્રમાણે શ્રી રામદેવજન જોઈતું હતું તે મળી ગયું. પ્રભુની લીલા ગહન છે. તેને કોઈ પામી શકતું નથી.    </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>{" "}
        </div>
      </div>
      <div>
        <Footer />
        {/* <AudioPlayer state={props.state} onPlay={(isPlay) => this.setState({ isPlay })} /> */}
      </div>
    </>
  );
};

export default BlogDetails4;
